export const fr = {
  typeaheads: {
    adminNonprofit: 'Organisation à but non lucratif',
    adminOpportunity: 'Opportunité',
    adminCompany: 'Entreprise',
    adminRsvpNonprofit: 'ex. Quest Food Exchange',
    adminSlackChannelSubscription: 'Canal Slack',
    purposelyAdminOpportunityRequest: "Demande d'opportunité",
    departments: 'Département',
    causes: 'Cause',
    rsvpEventRegions: 'Emplacement',
    companyAdminEmployeeCountries: 'Pays',
    companyAdminEmployeeRegions: 'Région',
    companyAdminSlackChannels: 'Canal Slack',
    companyAdminEmployees:
      'Tapez le nom du bénévole que vous souhaitez ajouter',
    adminNonprofit: 'Organisation à but non lucratif',
    adminOpportunity: 'Opportunité',
    adminCompany: 'Entreprise',
    adminRsvpNonprofit: 'Organisation à but non lucratif',
  },
}
